import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { StateService } from '../../services/state.service';
import { inject } from '@angular/core';
import { DateTime } from 'luxon';

export const anmeldeschlussAbgelaufenGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const stateService: StateService = inject(StateService);
  const router: Router = inject(Router);
  const token: string | null = route.paramMap.get('token');
  const anmeldeschluss: string | null = stateService.getAnmeldeschluss();

  if (anmeldeschluss !== null && DateTime.now() > DateTime.fromISO(anmeldeschluss)) {
    return router.createUrlTree(['/vp', token, 'anmeldeschluss-abgelaufen']);
  }
  return true;
};
